
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    current: {
      type: Number,
      required: true
    },
    last: {
      type: Number,
      required: true
    }
  },
  setup () {
    const pagePath = (pageNumber: number) => {
      const searchParams = new URLSearchParams(location.search)
      searchParams.set('p', pageNumber.toString())

      return location.pathname + '?' + searchParams.toString()
    }

    return { pagePath }
  }
})
